import React, { Component } from "react";
import * as yup from "yup";
import moment from "moment-timezone";
import { map, isEmpty } from "lodash";
import Loader from "../../../../../Common/Component/Loader";
import { formatToCurrency } from "../../../../../../Tools/formatToCurrency";

import { DatePicker, message, Modal, Select } from "antd";
const { Option } = Select;

class ViewEditInvoice extends Component {
  state = {
    loader: false,
    invoice_date: '',
    due_date: '',
    rows: [],
    description: '',
    serviceOrderNumberList: {},
    total: 0,
    sales_tax: 0,
    balance_due: 0,
    amount_received: 0,
    serviceOrder: {},
    addInvoice: {},
    editInvoice: {},
    invoiceDetail: {},
    showDelete: false,
    btn_active: true,
    deleteLineItems: [],
    isVoidClick: false,
    isApprove: false,
    errors: {},
    description_data: [],
    service_order_uuid: '',
    serviceList: [],
    changedLineItemIndex: -1
  }

  componentDidMount = () => {
    this.setState({ loader: true })
    this.props.getInvoiceById(this.props.invoice_uuid)
    this.props.getServiceOrderNumberList({ user__uuid: this.props.customerId })
    this.props.getInvoiceDescription(this.props.service_order_uuid)
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    const { serviceOrderNumberList, serviceOrder, editInvoice, invoiceDetail, isVoidClick } = this.state;
    // message.destroy()
    if (Object.keys(nextProps?.Invoice?.errors).length > 0
      && JSON.stringify(nextProps?.Invoice?.errors) !== JSON.stringify(this.props?.Invoice?.errors)) {
      this.setState({loader: false})
      message.error('Something went wrong', 10)
    }

    // get service order number list
    if (Object.keys(nextProps?.Invoice?.serviceOrderNumberList).length > 0
      && JSON.stringify(nextProps?.Invoice?.serviceOrderNumberList) !== JSON.stringify(serviceOrderNumberList)) {
      this.setState({ serviceOrderNumberList: nextProps?.Invoice?.serviceOrderNumberList });
    }

    // get service order
    if (Object.keys(nextProps?.ServiceOrder?.viewOrder).length > 0
      && JSON.stringify(nextProps?.ServiceOrder?.viewOrder) !== JSON.stringify(serviceOrder)) {
      this.setState({ serviceOrder: nextProps?.ServiceOrder?.viewOrder });
    }

    //Get Invoice Description
    if (Object.keys(nextProps?.InvoiceDescription?.data).length > 0 && nextProps?.InvoiceDescription?.data !== this.props.InvoiceDescription.data) {
      this.setState({
        loader: false,
        description_data: nextProps?.InvoiceDescription?.data
      })
    }

    if (Object.keys(nextProps?.InvoiceDescription?.errors).length > 0 && nextProps?.InvoiceDescription?.errors !== this.props.InvoiceDescription.errors) {
      message.error('Something went wrong', 10);
      this.setState({
        loader: false
      })
    }

    // add invoice
    if (Object.keys(nextProps?.Invoice?.invoiceDetail).length > 0
      && JSON.stringify(nextProps?.Invoice?.invoiceDetail) !== JSON.stringify(invoiceDetail)) {
      const invoiceDetail = nextProps?.Invoice?.invoiceDetail;
      if (invoiceDetail?.line_items?.length > 0) {
        for (let index = 0; index < invoiceDetail?.line_items?.length; index++) {
          const descriptionItem = nextProps?.InvoiceDescription.data.data.find(x => x.item === invoiceDetail?.line_items[index].description && x.type === invoiceDetail?.line_items[index].item_type);
          if (!descriptionItem) {
            invoiceDetail.line_items[index].other_description = invoiceDetail.line_items[index].sub_description;
            invoiceDetail.line_items[index].description = "other";
          }
        }
      }
      const serviceList = serviceOrderNumberList?.data?.find(x => x.uuid === invoiceDetail?.service_order?.uuid)
      this.setState({
        invoiceDetail,
        serviceOrder: invoiceDetail?.service_order,
        description: invoiceDetail?.notes,
        balance_due: invoiceDetail?.balance_due,
        sales_tax: invoiceDetail?.sales_tax,
        amount_received: invoiceDetail?.amount_received,
        credit_memo_amount_applied: invoiceDetail?.credit_memo_amount_applied,
        total: invoiceDetail?.total,
        invoice_date: invoiceDetail?.invoice_date,
        due_date: invoiceDetail?.due_date,
        service_order_uuid: invoiceDetail?.service_order?.uuid,
        service_order_number: invoiceDetail?.service_order?.service_order_number,
        serviceList: serviceList?.services
      },
      () => this.setLineItems());
    }

    // add invoice
    if (Object.keys(nextProps?.Invoice?.editInvoice).length > 0
      && JSON.stringify(nextProps?.Invoice?.editInvoice) !== JSON.stringify(editInvoice)) {
      this.setState({ editInvoice: nextProps?.Invoice?.editInvoice }, () => {
        if (isVoidClick) { this.setState({ isVoidClick: false }) } else { this.addLineItems() }
        if (this.state.isApprove) {
          this.props.finalizeInvoice(this.state?.editInvoice?.uuid)
          this.setState({ isApprove: false })
        }
      });
    }

    // get sales tax
    if (Object.keys(nextProps?.Invoice?.getSalesTax).length > 0
      && JSON.stringify(nextProps?.Invoice?.getSalesTax) !== JSON.stringify(this.props?.Invoice?.getSalesTax)) {
      const {rows, changedLineItemIndex} = this.state;
      rows[changedLineItemIndex].tax = nextProps?.Invoice?.getSalesTax?.total_tax
      this.setState({rows}, () => this.calculateTotal())
    }
    this.setState({ loader: false })
  }

  // convert date time from utc to local time
  UTCToLocal = (date) => {
    let stillUtc = moment.utc(date).toDate();
    return moment(stillUtc).local();
  }

  // convert date time from local to utc
  localToUTC = (date) => {
    return moment.utc(date)
  }

  // add line items
  addLineItems = () => {
    const { addInvoiceLineItem, editInvoiceLineItem, deleteInvoiceLineItem, getInvoiceList, onChangeView } = this.props;
    const { rows, invoiceDetail, deleteLineItems } = this.state;
    let arr = [];
    this.setState({ loader: true })
    map(rows, x => {
      // const per_idx = x?.tax?.indexOf('%');
      // const org_tax = x?.taxChecked ? per_idx > -1 ? x?.tax?.replace('%', '') : x?.tax : 0;
      // const tax = (parseFloat(x.price) * (org_tax / 100))
      if (x.uuid) { // update line items
        arr.push(editInvoiceLineItem(x.uuid, {
          service_uuid: x?.service_uuid,
          item_type: x.type,
          date: x.date ? this.localToUTC(x.date).format('YYYY-MM-DD') : null,
          description: x.description,
          sub_description: x?.description === 'other' ? x.other_description : '',
          price: x.price,
          // tax: tax || 0,
          // tax_percent: x.tax || 0,
          invoice_uuid: invoiceDetail?.uuid
        }))
      } else { // add line items
        arr.push(addInvoiceLineItem({
          service_uuid: x?.service_uuid,
          item_type: x.type,
          date: x.date ? this.localToUTC(x.date).format('YYYY-MM-DD') : null,
          description: x.description,
          sub_description: x?.description === 'other' ? x.other_description : '',
          price: x.price,
          // tax: tax || 0,
          // tax_percent: x.tax || 0,
          invoice_uuid: invoiceDetail?.uuid
        }))
      }
    })

    map(deleteLineItems, (uuid) => arr.push(deleteInvoiceLineItem(uuid))) // delete line items

    Promise.all(arr).then((response) => {
      if (!isEmpty(response)) {
        this.setState({ loader: true })
        getInvoiceList()
        onChangeView(0)
      }
    })
  }

  // set line items
  setLineItems = () => {
    const { invoiceDetail } = this.state;
    const rows = []
    map(invoiceDetail?.line_items, (x) => {
      rows.push({
        uuid: x.uuid, service_uuid: x?.service_uuid,type: x.item_type,
        date: this.UTCToLocal(x.date), description: x.description, price: x.price,
        // taxChecked: x.tax_percent ? true : false,
        tax: x.tax || '0',
        other_description: x.sub_description, service_code : x.service_code
      })
    })
    this.setState({ rows }, () => { this.calculateTotal() })
  }


  // get logged in user
  getLoggedInUserRole = () => {
    let authUser = JSON.parse(localStorage.getItem('authUser'))
    const logged_in_user_role = authUser?.user?.user_roles?.map(x => x.name)

    const is_business_dev_franchiese = logged_in_user_role?.includes('business_dev_franchiese')
    const is_call_center = logged_in_user_role?.includes('service_rep')
    return {is_business_dev_franchiese, is_call_center}
  }

  // toggle delete modal
  toggleDeleteModal = () => {
    this.setState((prevState) => ({ showDelete: !prevState.showDelete }))
  }

  // delete invoice
  onDeleteInvoice = () => {
    this.setState({ loader: true })
    this.props.deleteInvoice(this.props.invoice_uuid)
    setTimeout(() => { this.toggleDeleteModal(); this.props.onChangeView(0) }, 1000)
  }

  // validate numeric input
  onNumericInputChange = (value) => {
    const reg = /^-?\d*(\.\d*)?$/;
    return ((!isNaN(value) && reg.test(value)) || value === '' || value === '-')
  };

  // on invoice detail change
  onTextChange = (e, type) => {
    const value = type === 'bool' ? e.target.checked : e.target.value;
    this.setState({ [e.target.name]: value })
  }

  // on item row change
  onRowDataChange = (e, index, type) => {
    const { rows } = this.state;
    const value = type === 'bool' ? e.target.checked : e.target.value;
    Object.assign(rows[index], { [e.target.name]: value })
    this.setState({ rows, changedLineItemIndex: index }, () => {
      const {rows} = this.state;
      if (rows[index].service_uuid && rows[index].price && rows[index].type) {
        this.props.getSalesTax({service_uuid: rows[index].service_uuid, amount: rows[index].price, item_type: rows[index].type})
      } else if (isEmpty(rows[index].price)) {
        rows[index].tax = 0
        this.setState({rows}, () => this.calculateTotal())
      }
    })
  }

  // calculate total
  calculateTotal = () => {
    let { rows, amount_received } = this.state;
    let new_total = 0, salesTax = 0, balance_due = 0;
    map(rows, x => {
      salesTax = parseFloat(salesTax) + parseFloat(x?.tax)
      new_total = parseFloat(new_total) + parseFloat(x.price || 0)
      balance_due = parseFloat(balance_due) + (parseFloat(x.price || 0) + parseFloat(x.tax || 0))
    })
    this.setState({ total: new_total, sales_tax: salesTax, balance_due: parseFloat(balance_due - amount_received).toFixed(2) })
  }

  //on edit row
  onEditRow = (id_edit_invoice, index) => {
    const { rows } = this.state;
    Object.assign(rows[index], { 'isEditRow': id_edit_invoice })
    this.setState({ rows })
  }

  // on delete row
  onDeleteRow = (index) => {
    const { rows, deleteLineItems } = this.state;
    if (rows[index]?.uuid) deleteLineItems.push(rows[index]?.uuid)
    rows.splice(index, 1);
    this.setState({ rows, deleteLineItems }, () => { this.calculateTotal(); })
  }

  // on add item
  onAddItem = () => {
    const { rows } = this.state;
    rows.push({service_uuid: '', type: '', date: '', description: '', price: '', taxChecked: false, tax: '', isEditRow: false})
    this.setState({ rows })
  }

  // on service order change
  onServiceOrderChange = (e) => {
    const {serviceOrderNumberList, rows} = this.state;
    this.props.getServiceOrderById(e)
    this.props.getInvoiceDescription(e)
    this.setState({ 'service_order_uuid': e })
    const serviceList = serviceOrderNumberList?.data?.find(x => x.uuid === e)

    map(rows, x => {
      x.isEditRow = true
      const service_num = serviceList?.services?.find(y => y.uuid === x.service_uuid)
      if (isEmpty(service_num)) {
        x.service_uuid = ''
        x.service_code = ''
      }
    })

    this.setState({ 'serviceList': serviceList?.services, rows })
  }

  // validate required fields
  validate = () => {
    const { rows, invoice_date, due_date, service_order_uuid } = this.state;

    const schema = yup.object().shape({
      service_order_uuid: yup.string().required('Service order# is required'),
      rows: yup.array(yup.object({
        service_uuid: yup.string().required('Service#  is required'),
        type: yup.string().required('Type is required'),
        date: yup.string().required('Date is required'),
        description: yup.string().required('Description is required'),
        other_description: yup.string().when('description', {
          is: 'other',
          then: yup.string().required('Other Description is required'),
        }),
        price: yup.string().test('match', 'Price should have a valid format', (price) => {
          return !isNaN(parseFloat(price))
        }),
      })),
      invoice_date: yup.string().required('Invoice Date is required'),
      due_date: yup.string().required('Due Date is required').test("compare", "Invalid due date", (due_date) => moment(this.state.invoice_date).isBefore(moment(due_date))),
    });

    const data = { service_order_uuid, rows, invoice_date, due_date };

    setTimeout(() => {
      schema.validate(data, { abortEarly: false }).then(() => {
        this.setState({ btn_active: true, errors: {} })
        this.onSave();
      }).catch((error) => {
        let err_data = {};
        map(error.inner, (item) => { err_data[item.path] = item.message })
        this.setState({ errors: err_data, is_btn_active: false })
      });
    }, 500)
  };

  // on save
  onSave = () => {
    const { invoice_date, due_date, description, serviceOrder, balance_due, amount_received, invoiceDetail, service_order_uuid } = this.state;
    const { editInvoice, customerId, invoice_uuid } = this.props;
    const address = !isEmpty(serviceOrder?.billing_address) ? serviceOrder?.billing_address : !isEmpty(serviceOrder?.service_address) ? serviceOrder?.service_address : {};

    if (!address?.geo_location) {
      delete address?.geo_location
    }

    // map(rows, (item, i) => {
    //   if (!item.description) {
    //     delete rows[i]['description'];
    //   } else if (item.description === "other") {
    //     item.description = item.other_description;
    //     delete rows[i]['other_description'];
    //   }
    // });
    editInvoice(invoice_uuid, {
      user_uuid: customerId,
      invoice_date: invoice_date ? this.localToUTC(invoice_date).format('YYYY-MM-DD') : null,
      due_date: due_date ? this.localToUTC(due_date).format('YYYY-MM-DD') : null,
      // total: parseFloat(total || '0').toFixed(2),
      balance_due: balance_due || '0',
      amount_received: amount_received || '0',
      // sales_tax: parseFloat(sales_tax || '0').toFixed(2),
      status: invoiceDetail?.status,
      billing_address: address,
      billing_type: 'email',
      notes: description,
      service_order_uuid: service_order_uuid
    })
  }

  // render Item Row
  renderItemRow = (item, index) => {
    const { serviceList, errors } = this.state;

    return (
      <div className="divrow editrow" key={`items${index}`} style={{marginLeft: "0px"}}>
        <div className="dcell sno">
          <Select
            dropdownClassName="sm-filter"
            showArrow
            name={'service_uuid'}
            virtual={false}
            style={{ width: '100%' }}
            value={item?.service_uuid ? item?.service_uuid : undefined}
            placeholder={'Select'}
            onChange={(e) => {
              this.onRowDataChange({ target: { name: 'service_uuid', value: e } }, index)
            }}
          >
            {map(serviceList, (obj) => <Option value={obj?.uuid} key={obj?.uuid}>{obj?.service_code}</Option>)}
          </Select>
          {errors?.[`rows[${index}].service_uuid`] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.[`rows[${index}].service_uuid`]}</label> : ''}
        </div>
        <div className="dcell sdate">
          <DatePicker
            inputReadOnly
            style={{ 'width': '100%' }}
            name='date'
            format="MM/DD/YYYY"
            allowClear={false}
            value={item?.date ? moment(item?.date) : null}
            onChange={(e) => this.onRowDataChange({ target: { name: 'date', value: e } }, index)}
          />
          {errors?.[`rows[${index}].date`] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.[`rows[${index}].date`]}</label> : ''}
        </div>
        <div className="dcell stype">
          <Select
            dropdownClassName="sm-filter"
            showArrow
            name={'type'}
            virtual={false}
            style={{ width: '100%' }}
            value={item?.type ? item?.type : undefined}
            placeholder={'Product/Service'}
            onChange={(e) => { this.onRowDataChange({ target: { name: 'type', value: e } }, index) }}
          >
            <Option value="product">Product</Option>
            <Option value="service">Service</Option>
          </Select>
          {errors?.[`rows[${index}].type`] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.[`rows[${index}].type`]}</label> : ''}
        </div>
        <div className="dcell sdesc">
          <Select
            className="sdesc"
            value={item.description ? item.description : "Please Select"}
            placeholder="Please Select"
            onChange={(e) => { this.onRowDataChange({ target: { name: 'description', value: e } }, index) }}
          >
            {this.state.description_data?.data.filter(data => data.type === item?.type).map((item) => {
              return (
                <Option key={item.item}>{item.item}</Option>
              )
            })}
            <Option key="other">Other</Option>
          </Select>
          {errors?.[`rows[${index}].description`] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.[`rows[${index}].description`]}</label> : ''}
          {item.description === "other" ?
            <>
              <textarea
                className="sdesc mt-20"
                value={item.other_description}
                onChange={(e) => { this.onRowDataChange({ target: { name: 'other_description', value: e.target.value } }, index) }}
              ></textarea>
              {errors?.[`rows[${index}].other_description`] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.[`rows[${index}].other_description`]}</label> : ''}
            </>
            : null
          }
        </div>
        <div className="dcell sprice">
          <div className="sprice">
            <input
              type="text"
              className="form-control"
              value={item?.price}
              name="price"
              onChange={(e) => this.onNumericInputChange(e.target.value) && this.onRowDataChange(e, index)}
              placeholder="Price" />
            {errors?.[`rows[${index}].price`] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.[`rows[${index}].price`]}</label> : ''}
          </div>
        </div>  
        <div className="dcell stax edittax">
          <div className="flex ai-center">
            
            <div className="inline-check-list sm-checks">
              <div className="flex ai-center">
                <div className="sprice">
                  ${formatToCurrency(item?.tax)}
                </div>
              </div>
              {/* <div className="fitem-check">
                <input
                  type="checkbox"
                  className="fitem-ck-input"
                  id={`taxChecked${index}`}
                  name="taxChecked"
                  checked={item?.taxChecked}
                  onChange={(e) => { this.onRowDataChange(e, index, 'bool'); this.onRowDataChange({ target: { name: 'tax', value: '' } }, index) }} />
                <label htmlFor={`taxChecked${index}`} className="fitem-ck-txt"></label>
              </div>
              {
                item?.taxChecked ? <input
                  type="text"
                  className="form-control"
                  value={item?.tax}
                  name="tax"
                  onChange={(e) => (e.target.value.indexOf('%') > 0 || this.onNumericInputChange(e.target.value)) && this.onRowDataChange(e, index)}
                  placeholder="Tax" /> : ''} */}
            </div>
          </div>
          <i className="las la-trash-alt" onClick={() => this.onDeleteRow(index)} />
        </div>
      </div>
    )
  }

  // render Item Row
  renderLineItemRow = (item, index) => {
    const { invoiceDetail, serviceList, errors } = this.state;
    const {is_business_dev_franchiese, is_call_center} = this.getLoggedInUserRole();
    return (
      <div className={item.isEditRow?"divrow editrow":"divrow"} key={`items${index}`} style={{marginLeft: "0px"}}>
        {item.isEditRow ? <div className="dcell sno">
          <Select
            dropdownClassName="sm-filter"
            showArrow
            name={'service_uuid'}
            virtual={false}
            style={{ width: '100%' }}
            value={item?.service_uuid ? item?.service_uuid : undefined}
            placeholder={'Service#'}
            onChange={(e) => {
              this.onRowDataChange({ target: { name: 'service_uuid', value: e } }, index)
            }}
          >
            {map(serviceList, (obj) => <Option value={obj?.uuid} key={obj?.uuid}>{obj?.service_code}</Option>)}
          </Select>
          {errors?.[`rows[${index}].service_uuid`] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.[`rows[${index}].service_uuid`]}</label> : ''}
        </div> : <div className="dcell sdate">{item?.service_code}</div>}
        {item.isEditRow ? <div className="dcell sdate"><DatePicker
          inputReadOnly
          style={{ 'width': '100%' }}
          name='date'
          format="MM/DD/YYYY"
          allowClear={false}
          value={item?.date ? moment(item?.date) : null}
          onChange={(e) => this.onRowDataChange({ target: { name: 'date', value: e } }, index)}
        /></div> : <div className="dcell sdate">{moment(item?.date).format('MM/DD/YYYY')}</div>
        }
        {errors?.[`rows[${index}].date`] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.[`rows[${index}].date`]}</label> : ''}
        {item.isEditRow ? <div className="dcell stype"><Select
          dropdownClassName="sm-filter"
          showArrow
          name={'type'}
          virtual={false}
          style={{ width: '100%' }}
          value={item?.type ? item?.type : undefined}
          placeholder={'Product/Service'}
          onChange={(e) => { this.onRowDataChange({ target: { name: 'type', value: e } }, index) }}
        >
          <Option value="product">Product</Option>
          <Option value="service">Service</Option>
        </Select></div> : <div className="dcell stype">{item?.type}</div>}
        {errors?.[`rows[${index}].type`] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.[`rows[${index}].type`]}</label> : ''}
        {item.isEditRow ?
          <div className="dcell sdesc">
            <Select
              value={item.description ? item.description : "Please Select"}
              placeholder="Please Select"
              onChange={(e) => { this.onRowDataChange({ target: { name: 'description', value: e } }, index) }}
            >

              {this.state.description_data?.data.filter(data => data.type === item?.type).map((item) => {
                return (
                  <Option key={item.item}>{item.item}</Option>
                )
              })}
              <Option key="other">Other</Option>
            </Select>
            {item.description === "other" ?
              <textarea
                className="sdesc mt-20"
                value={item.other_description}
                onChange={(e) => { this.onRowDataChange({ target: { name: 'other_description', value: e.target.value } }, index) }}
              ></textarea>
              : null
            }
          </div>
          : <div className="dcell sdesc">{item?.description === 'other' ? item?.other_description : item?.description}</div>}
        <div className="dcell sprice">
          {item.isEditRow ? <input
            type="text"
            className="form-control"
            value={item?.price}
            name="price"
            onChange={(e) => this.onNumericInputChange(e.target.value) && this.onRowDataChange(e, index)}
            placeholder="Price" /> : <div className="sprice">{item?.price}</div>}
          {errors?.[`rows[${index}].price`] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.[`rows[${index}].price`]}</label> : ''}
        </div>
        <div className={item.isEditRow?"dcell stax edittax":"dcell stax"}>
          <div className="flex ai-center">
            <div className="inline-check-list sm-checks">
              <div className="flex ai-center">
                <div className="sprice">
                  ${formatToCurrency(item?.tax || '0')}
                </div>
              </div>
              {/* <div className="fitem-check">
                <input
                  type="checkbox"
                  className="fitem-ck-input"
                  id={`taxChecked${index}`}
                  name="taxChecked"
                  checked={item?.taxChecked}
                  onChange={(e) => { this.onRowDataChange(e, index, 'bool'); this.onRowDataChange({ target: { name: 'tax', value: '' } }, index) }} />
                <label htmlFor={`taxChecked${index}`} className="fitem-ck-txt"></label>
              </div>
              {
                item?.taxChecked ? <input
                  type="text"
                  className="form-control"
                  value={item?.tax}
                  name="tax"
                  onChange={(e) => (e.target.value.indexOf('%') > 0 || this.onNumericInputChange(e.target.value)) && this.onRowDataChange(e, index)}
                  placeholder="Tax" /> : ''} */}
            </div>
          </div>
          {(!is_business_dev_franchiese && !is_call_center) ? invoiceDetail.status !== 'void' ? item?.isEditRow ? <i className="las la-save" onClick={() => this.onEditRow(false, index)}></i>
            : <i className="las la-edit" onClick={() => this.onEditRow(true, index)}></i> : "" : ''}

          {is_call_center ? <i className="las la-trash-alt" onClick={() => this.onDeleteRow(index)}></i> : ''}
        </div>
      </div>
    )
  }

  // render table
  renderItemTable = () => {
    const { 
      rows,
      description,
      total,
      amount_received,
      balance_due,
      sales_tax,
      credit_memo_amount_applied
    } = this.state;
    const {
      is_business_dev_franchiese,
      is_call_center
    } = this.getLoggedInUserRole();
    const is_payment_recieved = Number(amount_received || "0") > 0

    return (
      <React.Fragment>
        <div className="table-block">
          <div className="div-table">
            <div className="divhead">
              <div className="dcell sno">Service #</div>
              <div className="dcell sdate">Date</div>
              <div className="dcell stype">Type</div>
              <div className="dcell sdesc">Description</div>
              <div className="dcell sprice">Price</div>
              <div className="dcell stax">Tax</div>
            </div>
            <div className="divbody">
              {map(rows, (item, index) => item?.uuid ? this.renderLineItemRow(item, index) : this.renderItemRow(item, index))}
              <div className="divrow dfoot">
                <div className="dcell">
                  <div className="btn-group">
                    <button disabled={(is_business_dev_franchiese || is_call_center || is_payment_recieved)} className={`btn ${(is_business_dev_franchiese || is_call_center || is_payment_recieved) ? 'disabled' : 'btn-warning'}`} onClick={() => this.onAddItem()}>Add Another Line</button>
                    <button disabled={(is_business_dev_franchiese || is_call_center || is_payment_recieved)} className={`btn ${(is_business_dev_franchiese || is_call_center || is_payment_recieved) ? 'disabled' : 'btn-warning'}`} onClick={() => this.setLineItems()}>Clear All</button>
                  </div>
                  <div className="form-group">
                    <div className="fitem">
                      <textarea
                        rows="2"
                        className="form-control"
                        name="description"
                        placeholder={"Add a message to your invoice"}
                        value={description}
                        onChange={(e) => this.onTextChange(e)} />
                    </div>
                  </div>
                </div>
                <div className="dcell flex ai-start flex-end">
                  <div className="price-block">
                    <span>Total</span>
                    <span>Sales Tax</span>
                    <span>Amount Received </span>
                    <span>Credit Applied</span>
                    <span>Balance Due</span>
                  </div>
                  <div className="pricing">
                    <span>${total ? formatToCurrency(total)() : '0.00'}</span>
                    <span>${sales_tax ? formatToCurrency(sales_tax)() : '0.00'}</span>
                    <span>${amount_received ? formatToCurrency(amount_received)() : '0.00'}</span>
                    <span>${credit_memo_amount_applied ? formatToCurrency(credit_memo_amount_applied)() : '0.00'}</span>
                    <span>${balance_due ? formatToCurrency(balance_due)() : '0.00'}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    )
  }

  render() {
    const { loader, invoice_date, due_date, serviceOrder, invoiceDetail, showDelete, errors, service_order_uuid, serviceOrderNumberList } = this.state;
    const { onChangeView, customer, getInvoiceList } = this.props;
    const {is_business_dev_franchiese, is_call_center} = this.getLoggedInUserRole()
    const is_service_order = !isEmpty(serviceOrder?.billing_address) || !isEmpty(serviceOrder?.service_address)
    const address = !isEmpty(serviceOrder?.billing_address) ? serviceOrder?.billing_address : !isEmpty(serviceOrder?.service_address) ? serviceOrder?.service_address : {};
    return (
      <React.Fragment>
        {loader && <Loader />}
        <div className="filter_wrapper">
          <ul className="breadcrumb">
            <li className={"cursor_pointer"}><span onClick={() => { onChangeView(0) }}>Back to all invoices</span></li>
          </ul>
        </div>
        <div className="invoice-container">
          <h4>#{invoiceDetail?.invoice_id}</h4>
          <div className="flex flex-service-cus">
            <div className="flex-1">
              <div className="bill-add">
                <b>Bill to:</b>
                <p>{customer?.first_name} {customer?.last_name} <br />{is_service_order ? `${address?.address}` : ''} <br />{is_service_order ? `${address?.city}, ${address?.state}, ${address?.zip_code}` : ''}</p>
              </div>
            </div>
            <div className="flex-1">
              <div className="form-group">
                <div className="half-fitem fitem">
                  <div className="half-fitem fitem">
                    <label><b>Service Order#</b></label>
                    <Select
                      dropdownClassName="sm-filter"
                      showArrow
                      name={'service_order'}
                      virtual={false}
                      style={{ width: '100%' }}
                      value={service_order_uuid ? service_order_uuid : undefined}
                      placeholder={'Service Order#'}
                      onChange={(e) => this.onServiceOrderChange(e)}
                    >
                      {map(serviceOrderNumberList?.data, (obj) => <Option value={obj?.uuid} key={obj?.uuid}>{obj?.service_order_number}</Option>)}
                    </Select>
                    {errors?.['service_order_uuid'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['service_order_uuid']}</label> : ''}
                  </div>
                  <div className="half-fitem fitem">
                    <label><b>Invoice Date</b></label>
                    <DatePicker
                      inputReadOnly
                      style={{ 'width': '100%' }}
                      // disabledDate={(current) => { return current && current <= moment().endOf('day'); }}
                      name='date'
                      format="MM/DD/YYYY"
                      allowClear={false}
                      value={invoice_date ? moment(invoice_date) : null}
                      onChange={(e) => this.onTextChange({ target: { name: 'invoice_date', value: e } })}
                    />
                    {errors?.['invoice_date'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['invoice_date']}</label> : ''}
                  </div>
                  <div className="half-fitem fitem">
                    <label><b>Due Date</b></label>
                    <DatePicker
                      inputReadOnly
                      style={{ 'width': '100%' }}
                      disabledDate={(current) => { return current && current <= moment().endOf('day'); }}
                      name='date'
                      format="MM/DD/YYYY"
                      allowClear={false}
                      value={due_date ? moment(due_date) : null}
                      onChange={(e) => this.onTextChange({ target: { name: 'due_date', value: e } })}
                    />
                    {errors?.['due_date'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['due_date']}</label> : ''}
                  </div>
                </div>
              </div>
            </div>
          </div>
          {this.renderItemTable()}
          <div className="sticky-btn-grp">
            <div className="flex ai-center">
              {(is_business_dev_franchiese || is_call_center) ? '' : <div className="flex-1 text-left links">
                <span onClick={() => this.toggleDeleteModal()}>Delete</span>
                <span onClick={() => {
                  this.setState({ loader: true, isVoidClick: true }, () => {
                    this.props.voidInvoice(this.props.invoice_uuid);
                    setTimeout(() => { getInvoiceList(); onChangeView(0); }, 1000)
                  })
                }}>Void</span>
              </div>}
              <div className="flex-1">
                <button disabled={(is_business_dev_franchiese || is_call_center)} className={`btn ${(is_business_dev_franchiese || is_call_center) ? 'disabled' : 'btn-warning'}`} onClick={() => this.validate()}>Save</button>
                <button disabled={(is_business_dev_franchiese || is_call_center)} className={`btn ${(is_business_dev_franchiese || is_call_center) ? 'disabled' : 'btn-warning'}`} onClick={() => this.setState({ isApprove: true }, () => this.validate())}>Approve & Send Invoice</button>
              </div>
            </div>
          </div>
        </div>
        <Modal
          title="Delete Customer"
          visible={showDelete}
          onCancel={() => this.toggleDeleteModal()}
          className="delete_user_modal"
          width={400}
          footer={[
            <button key="cancel" className="btn btn-brand btn-bdr" onClick={() => this.toggleDeleteModal()}>No</button>,
            <button key="upload" className={`btn btn-waning`} onClick={() => this.onDeleteInvoice()}>Yes</button>,
          ]}
        >
          <div>
            <h2> Are You Sure ?</h2>
          </div>
        </Modal>

      </React.Fragment>
    );
  }
}

export default ViewEditInvoice;